import { SET_APP_STATE} from '../actions/index';

export default function appState(state = {}, action) {
    switch (action.type){
        case SET_APP_STATE:
            localStorage.setItem('appState', JSON.stringify(action.appState));
            return Object.assign({}, state, action.appState)
        default:
            return state;
    }
}
